import { useApi } from 'api/api-context';
import { useCallback } from 'react';

export interface HrTermTypeSelectOption {
  value: number;
  label: string;
  isGlobal: boolean;
  organizationIds: number[];
  kind?: string;
  defaultRecurrence?: { quantity: number; unit: string };
  variants?: Array<{ variantId: number; name: string; description: string }>;
}

/** Loads authoritative term-type options scoped by PHP to the actor's accessible organizations. */
export default function useHrTermTypeOptions(includeArchived: boolean) {
  const { getAction } = useApi();

  return useCallback(async (): Promise<HrTermTypeSelectOption[]> => {
    const termTypes = await getAction('HrListTermTypes')({ query: { filters: { includeArchived } } });
    return termTypes
      .filter((termType) => termType.termTypeId !== undefined)
      .map((termType) => ({
        value: termType.termTypeId!,
        label: termType.name ?? `Typ ${termType.termTypeId}`,
        isGlobal: termType.isGlobal,
        organizationIds: termType.organizations.map((organization) => organization.organizationId),
        kind: termType.kind,
        defaultRecurrence: termType.defaultRecurrence,
        variants: termType.variants,
      }));
  }, [getAction, includeArchived]);
}
